import { createFileRoute } from '@tanstack/react-router'
import { WorkListPage } from '@/features/work/work-list-page'
export const Route = createFileRoute('/_console/work/')({ component: WorkListPage })
